import React from 'react';
import { object, arrayOf, func } from 'prop-types';

export default function NoItems({ items, resetFilters }) {
    if (items && items.length) return null;

    return (
        <div className="listing-no-results">
            <h2>No results found</h2>
            <p>
                There are no items that match your query or date range,
                use the filters to change the date range or adjust filters or
                <button onClick={resetFilters}>reset filters</button>.
            </p>
        </div>
    );
}

NoItems.propTypes = {
    items: arrayOf(object).isRequired,
    resetFilters: func.isRequired
};
